import { FieldArray } from 'formik';
import { getColorVariantFromBackground } from '@klv/shared/utils/functions';

import * as s from './styles';

import type { IDynamicTextFormField } from './types';

const DynamicTextFormField = ({
  maxFields,
  name,
  values,
  backgroundColor,
  addButtonText = 'add',
  ...rest
}: IDynamicTextFormField) => (
  <s.Container>
    <FieldArray
      name={name}
      render={arrayHelpers => (
        <>
          {values.map((_, index) => (
            <s.StyledDynamicTextFormField key={index}>
              <s.TextInputWrapper>
                <s.StyledTextInput
                  backgroundColor={backgroundColor}
                  {...rest}
                  name={`${name}.${index}`}
                />
              </s.TextInputWrapper>
              {values.length > 1 && (
                <s.StyledButtonContainer>
                  <s.StyledDeleteButton
                    action={() => arrayHelpers.remove(index)}
                    variant='ghost'
                    text='X'
                    type='button'
                    buttonColor={getColorVariantFromBackground(backgroundColor || 'light')}
                  />
                </s.StyledButtonContainer>
              )}
            </s.StyledDynamicTextFormField>
          ))}
          <s.StyledAddButton
            variant='none'
            text={addButtonText}
            type='button'
            $disabled={values.length >= maxFields}
            action={() => arrayHelpers.push('')}
          />
        </>
      )}
    />
  </s.Container>
);

export default DynamicTextFormField;
